/* @flow */

import React from 'react';
import type { $BaseWidgetState } from '../../types/BaseWidgetState';
import { getWidgetFieldByKey, getWidgetLinkSpanValue } from '../../utils/WidgetFieldUtils';
import { getWidgetFieldValue } from '../../utils/WidgetFieldUtils';
import { getWidgetFieldValueByKey } from '../../utils/WidgetFieldUtils';
import { showWidgetField } from '../../utils/WidgetFieldUtils';

type $Props = {
  widgetFieldKey: string,
  widgetState: $BaseWidgetState,
  modifierClass?: Array<string>;
};

const WidgetParagraph = (props: $Props) => {
  const { widgetFieldKey, widgetState, modifierClass } = props;
  const field = getWidgetFieldByKey(widgetState.widgetFields, widgetFieldKey);
  if (!showWidgetField(widgetState.settings, widgetFieldKey, widgetState.configuration || {})) return false;
  if (field) {
    const cssClassName = [...field.css || [], ...modifierClass || []].join(' ');
    let fieldValue = getWidgetLinkSpanValue(
      field,
      widgetState.settings.market,
      getWidgetFieldValue(field, widgetState)
    );
    if (fieldValue) {
      const prefix = getWidgetFieldValueByKey(field.prefix || '', widgetState);
      const showPrefix = showWidgetField(widgetState.settings, field.prefix || '')
      const prefixIco = field.wbIconName;
      if (showPrefix && (prefixIco || prefix)) {
        if (prefixIco) {
          return (
            <p id={field.id} className={cssClassName}>
              <span className="dl-ddw-dealer-link__prefix-ico">
                <wb-icon name={prefixIco} />
              </span >
              <span className="dl-ddw-pgph-value">{fieldValue}</span>
            </p>
          );
        } else if (prefix) {
          return (
            <p id={field.id} className={cssClassName}>
              <span className="dl-ddw-pgph-prefix">{prefix}</span>
              { " "}
              <span className="dl-ddw-pgph-value">{fieldValue}</span>
            </p>
          );
        }
      }
      else return (
        <p id={field.id} className={cssClassName}>{fieldValue}</p>
      );
    }
    else return null;
  }
  else return null;
};

export default WidgetParagraph;
